import { fetchApiJson } from "@utils/request";

import { DealEventPropertiesDTO } from "@organisms/deal-event-properties/domain/deal-event-properties";

export async function getDealEventProperties(resultUuid: string): Promise<DealEventPropertiesDTO> {
  return await fetchApiJson(
    `${process.env.GATSBY_API_BASE}/results/${resultUuid}/deal_event_properties/`
  );
}
